<template>
    <v-row>
        <v-col cols="12">
            <v-row>
                <v-col
                    v-for="template in mixin_base_templates"
                    :key="template.id"
                    cols="12"
                    xl="6"
                >
                    <m-lightbox-template-card
                        :template="template"
                        :theme="theme"
                        :lightbox_params="lightbox_params"
                        :is_selected="selected_template_id === template.id"
                        @select="onTemplateSelect"
                    />
                </v-col>
            </v-row>
        </v-col>
    </v-row>
</template>

<script>
import _ from 'lodash';
import mLightboxTemplateCard from './m-lightbox-template-card.vue';
import LightboxTemplates from '@/mixins/lightbox/lightbox-templates.js';

export default {
    name: 'mLightboxTemplateGallery',

    mixins: [LightboxTemplates],

    components: {
        mLightboxTemplateCard
    },

    props: {
        lightbox_params: {
            type: Object,
            default: null,
        },

        selected_template_id: {
            type: String,
            default: null,
        },

        theme: {
            type: Object,
            default: () => ({}),
        }
    },

    computed: {
        selected_template() {
            return this.mixin_base_templates.find(t => t.id === this.selected_template_id);
        },
    },

    methods: {
        onTemplateSelect(template) {
            if (this.selected_template_id === template.id) {
                this.$emit('template-deselected');
            } else {
                this.$emit('template-selected', template);
            }
        },
    },
}
</script>

<style scoped lang="scss"></style>